import { render, staticRenderFns } from "./community-tree.vue?vue&type=template&id=137998df&scoped=true&"
import script from "./community-tree.vue?vue&type=script&lang=js&"
export * from "./community-tree.vue?vue&type=script&lang=js&"
import style0 from "./community-tree.vue?vue&type=style&index=0&id=137998df&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137998df",
  null
  
)

export default component.exports